<template>
  <div class="exam-uniform-student-score-exam-input"
       :class="{'is-pass': isScorePass, 'is-fail': isScoreFail}">
    <template v-if="cellValue">
      <div class="value">{{valueText}}</div>
    </template>
    <template v-else>
      <span class="not-join"></span>
    </template>
  </div>
</template>

<script>
import objectUtils from '../../../../../../../../../../util/objectUtils'
export default {
  name: 'ExamUniformStudentScoreExamValue',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    cellValue: String,
    cellParam: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    subjectScore () {
      const cellParam = this.cellParam
      if (cellParam) {
        const subjectId = cellParam.subjectId
        if (subjectId) {
          return this.rowData[`score_${subjectId}`]
        }
      }
    },
    subjectScoreStatus () {
      const cellParam = this.cellParam
      if (cellParam) {
        const subjectId = cellParam.subjectId
        if (subjectId) {
          return this.rowData[`status_${subjectId}`]
        }
      }
    },
    valueText () {
      const score = this.subjectScore
      if (objectUtils.hasValue(score)) {
        const scoreStatus = this.subjectScoreStatus
        return `${scoreStatus}: ${score}`
      }
    },
    passScore () {
      const cellParam = this.cellParam
      if (cellParam) {
        const subjectId = cellParam.subjectId
        if (subjectId) {
          return this.rowData[`pass_${subjectId}`]
        }
      }
    },
    isScorePass () {
      const passScore = this.passScore
      if (passScore) {
        return passScore === '1'
      }
    },
    isScoreFail () {
      const passScore = this.passScore
      if (passScore) {
        return passScore !== '1'
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../../../styles/color";
  .exam-uniform-student-score-exam-input {
    &.is-pass {
      & > .value {
        color: $set-success-color;
      }
    }
    &.is-fail {
      & > .value {
        color: $set-danger-color;
      }
    }
    & > .value {
      &:empty {
        &:before {
          content: '\672a\5f55\5206';
          color: $set-empty-color;
        }
      }
    }
    & > .not-join {
      &:before {
        content: '\002f';
        color: $set-empty-color;
      }
    }
  }
</style>
